import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../images/profitlogo.png';
import './Header.css';

const Header = ({ onServiceClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isMenuOpen) {
      setIsServicesOpen(false);
    }
  };

  const toggleServices = () => {
    setIsServicesOpen(!isServicesOpen);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 100; // Approximate header height
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
    setIsMenuOpen(false);
  };

  const handleHomeClick = () => {
    if (location.pathname === '/') {
      scrollToSection('home');
      window.history.pushState(null, '', '/');
    } else {
      // Navigate to home page
      window.location.href = '/';
    }
    setIsMenuOpen(false);
  };

  const handleSectionClick = (sectionId) => {
    if (location.pathname === '/') {
      scrollToSection(sectionId);
      window.history.pushState(null, '', `/${sectionId}`);
    } else {
      // Navigate to home page and scroll to section
      window.location.href = `/${sectionId}`;
    }
    setIsMenuOpen(false);
    setIsServicesOpen(false);
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="top-contact-bar">
        <div className="container">
          <div className="contact-info-top">
            <div className="contact-item-top">
              <span className="contact-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V21a1 1 0 01-1 1C11.4 22 2 12.6 2 1a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"/>
                </svg>
              </span>
              <a href="tel:+14379287760" className="contact-link-top">+1 437-928-7760</a>
            </div>
            <div className="contact-separator">|</div>
            <div className="contact-item-top">
              <span className="contact-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </span>
              <a href="mailto:Profitpioneersinfo@gmail.com" className="contact-link-top">Profitpioneersinfo@gmail.com</a>
            </div>
            <div className="contact-separator">|</div>
            <div className="contact-item-top">
              <span className="contact-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"/>
                </svg>
              </span>
              <span className="contact-text-top">28 Grand Circuit Court, Brampton, ON L6Y 1A4</span>
            </div>
            <div className="contact-separator">|</div>
            <div className="social-links-top">
              <a href="https://instagram.com/profit_pioneers_" target="_blank" rel="noopener noreferrer" className="social-link-top" aria-label="Instagram">
                <svg className="instagram-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H7zm5 3a5 5 0 110 10 5 5 0 010-10zm0 2.2a2.8 2.8 0 100 5.6 2.8 2.8 0 000-5.6zm4.8-3.7a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" fill="currentColor"/>
                </svg>
                <span className="instagram-username">@profit_pioneers_</span>
              </a>
              <div className="contact-separator">|</div>
              <a href="https://maps.app.goo.gl/qoRRrYXjZ9TqT5w46" target="_blank" rel="noopener noreferrer" className="social-link-top" aria-label="Visit us on Google Maps">
                <svg className="google-maps-icon" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="currentColor"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="currentColor"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="currentColor"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="currentColor"/>
                </svg>
                <span className="visit-text">Visit us</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        {/* Top row: Logo (left), Nav (center), Actions (right) */}
        <div className="header-top">
          {/* Logo */}
          <div className="logo">
            <div className="logo-text">
              <h2>Profit Pioneers</h2>
              <span>Accounting & Bookkeeping Inc.</span>
            </div>
          </div>

          {/* Navigation */}
          <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
            <ul className="nav-list">
              <li><button onClick={handleHomeClick} className="nav-link">Home</button></li>
              <li className="dropdown">
                <button className="nav-link dropdown-toggle" onClick={toggleServices}>Services</button>
                <ul className={`dropdown-menu ${isServicesOpen ? 'open' : ''}`}>
                  <li><Link to="/services/taxation" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>Taxation</Link></li>
                  <li><Link to="/services/gst-hst" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>GST/HST Filing</Link></li>
                  <li><Link to="/services/financial-planning-consultation" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>Financial Planning & Consultation</Link></li>
                  <li><Link to="/services/incorporation" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>Business Incorporation</Link></li>
                  <li><Link to="/services/bookkeeping" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>Bookkeeping Services</Link></li>
                  <li><Link to="/services/wsib-filing" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>WSIB Filing</Link></li>
                  <li><Link to="/services/payroll" className="dropdown-link" onClick={() => { setIsServicesOpen(false); setIsMenuOpen(false); }}>Payroll Services</Link></li>
                </ul>
              </li>
              <li><button onClick={() => handleSectionClick('about')} className="nav-link">About Us</button></li>
              <li><button onClick={() => handleSectionClick('process')} className="nav-link">How We Work</button></li>
              <li><button onClick={() => handleSectionClick('contact')} className="nav-link">Contact Us</button></li>
            </ul>
            {/* Mobile-only CTA (shown when menu expands) */}
            <div className="header-cta-mobile">
              <button 
                onClick={() => { handleSectionClick('contact'); }} 
                className="btn btn-primary"
              >
                Get in Touch
              </button>
            </div>
          </nav>

          {/* Actions: Desktop CTA and Mobile Menu Button */}
          <div className="header-actions">
            <div className="header-cta">
              <button 
                onClick={() => handleSectionClick('contact')} 
                className="btn btn-primary"
              >
                Get in Touch
              </button>
            </div>
            <button 
              className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

      </div>
    </header>
    </>
  );
};

export default Header;
